<template>
  <div class="col-12">
    <h3>Dúvidas <span class="text-white">{{ course }}</span></h3>

    <div v-if="doubts.data">
      <div v-if="doubts.data.length === 0" class="w-100">
        <p class="text-center text-dark">Nenhuma dúvida em aberto, PARABÉNS!!!!</p>
      </div>
      <div v-else class="w-100">
        <div class="card col-12 py-3 mb-2" v-for=" doubt,i in doubts.data " :key="i">
          <div class="card-title mb-0">
            <h5>Pergunta feita em {{ doubt.created_at }}</h5>
          </div>
          <div class="card-body p-0">
            <div class="w-100 d-block d-md-flex justify-content-lg-between mb-2">
              <div><small>Curso: <b>{{ doubt.course.name }}</b></small></div>
              <div><small>Aula: <b>{{ doubt.leason.name }}</b></small></div>
            </div>

            <div class="w-100 d-block d-md-flex justify-content-lg-between mb-2">
              <div><small>Usuário: <b>{{ doubt.user.name }}</b></small></div>
              <div><small>Email: <b>{{ doubt.user.email }}</b></small></div>
            </div>

            <hr>
            <p>{{ doubt.ask }}</p>
            <hr>

            <div class="w-100 text-right" v-if="canEdit">
              <textarea class="form-control textarea" v-model="doubt.answer"></textarea>
              <button class="btn btn-sm mt-2 btn-danger mr-1" @click="spanDoubts( doubt )">Isso é Span</button>
              <button class="btn btn-sm mt-2 btn-success" @click="postDoubts( doubt )">Responder</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagination :data="doubts" :limit="2" size="small" @pagination-change-page="getDoubts"></pagination>
  </div>
</template>

<script>
import Axios from 'axios'
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
export default {
  props: {
    course: {
      default: undefined
    },
    leason: {
      default: undefined
    },
    canEdit: {
      default: true
    }
  },
  data () {
    return {
      description: '',
      doubts: {},
      page: 1
    }
  },
  computed: {
    ...mapGetters({
      user: 'getCurrentUser'
    })
  },
  methods: {
    postDoubts: function ( item ) {
      if ( !item.answer ) return
      this.storeDoubt(item)
    },

    spanDoubts: function (item) {
      item.is_actived = false
      this.storeDoubt(item)
    },

    storeDoubt: function (item) {
      Axios.post(`/course/leason/doubts`, {
        id: item.id,
        course_id: item.course_id,
        course_leason_id: item.course_leason_id,
        user_id: item.user_id,
        teacher_id: this.user.id,
        ask: item.ask,
        answer: item.answer,
        likes: item.likes,
        is_actived: item.is_actived
      })
        .then( res => {
          Swal.fire({
            icon:'success',
            title: 'Ótimo!',
            text: 'Salva com sucesso.'
          })
          this.getDoubts()
        })
        .catch( err => {
          Swal.fire({
            icon:'error',
            title: 'Opss!',
            text: 'Algo deu errado, tente novamente mais tarde.'
          })
          console.error( err )
        })
    },

    getDoubts: function (page=1) {
      let params;

      if(this.course != undefined){
        params = {
          'type': 'tea',
          'course': this.course,
          'page': this.page,
        }
      } else {
        params = {
          'type': 'tea',
          'teacher': this.user.id,
          'page': this.page,
        }
      }

      this.page = page
      Axios.get(`/course/leason/doubts`, {
        params: params
      })
        .then( res => {
          this.doubts = res.data
        })
        .catch( err => {
          console.error( err )
        })
    }
  },
  mounted () {
    this.getDoubts()
  }
}
</script>
